import React from 'react';

const ProfileForm = ({ admin, form, setForm, onSubmit, onCancel, error, loading }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  return (
    <form onSubmit={onSubmit} className="modal-form" autoComplete="off">
      <input 
        type="text" 
        placeholder="Name" 
        name="name"
        value={form.name} 
        onChange={handleChange} 
        required 
      />
      <input 
        type="email" 
        placeholder="Email" 
        name="email"
        value={form.email} 
        onChange={handleChange} 
        required 
      />
      <input 
        type="tel" 
        placeholder="Mobile Number" 
        name="mobile"
        value={form.mobile || ''} 
        onChange={handleChange} 
      />
      <input 
        type="text" 
        placeholder="Role" 
        value={admin?.role || ''} 
        disabled 
        className="disabled-input"
        style={{backgroundColor: '#f3f4f6', color: '#6b7280', cursor: 'not-allowed'}}
      />
      <div className="modal-actions">
        <button type="submit" disabled={loading}>
          {loading ? 'Updating...' : 'Update Profile'}
        </button>
        <button type="button" onClick={onCancel}>Cancel</button>
      </div>
      {error && <div className="error">{error}</div>}
    </form>
  );
};

export default ProfileForm;
